/**
 * Define which newsletters this widget offers subscriptions to
 */

const mailingLists = [
  {
    title: "FWA Newsletter",
    id: "5149cbb6-c1b0-4b6a-88a3-42f76af14f55",
  },
  {
    title: "Constore",
    id: "7c14a976-a304-4e6e-b033-3b9f9e2dcf26",
  },
  {
    title: "Registration Announcements",
    id: "3638c700-e610-4a70-a334-42504b641279",
  },
]

export default mailingLists
